"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
const graphql_1 = require("../../../graphql");
const OsmosysResourcePage_1 = require("../../../comps/reusables/OsmosysResourcePage");
const routeContainers_1 = require("../../../comps/routeContainers");
const Nav_1 = require("./Nav");
const index_1 = require("./Routes/index");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const NewEmailView_1 = require("../Emails/EmailHome/NewEmailView");
exports.EmailTemplateDetail = () => {
    const { match: { params: { id }, }, } = use_react_router_1.default();
    return (react_1.default.createElement(reusables_1.OsmosysResourcePage, { query: graphql_1.emailTemplate, skip: !id, paths: {
            item: 'emailTemplate',
        }, variables: { id: id }, getTitle: data => data.emailTemplate.name, getSubTitle: () => 'Email Template', getNav: () => {
            return react_1.default.createElement(Nav_1.Nav, { activeTab: "", emailTemplateId: id });
        }, getHeaderBody: data => {
            if (!data.emailTemplate) {
                return null;
            }
            if (data.emailTemplate.productionVersion) {
                return (react_1.default.createElement(NewEmailView_1.NewEmailView, { template: data.emailTemplate, templateVersion: data.emailTemplate.productionVersion },
                    "Start new email with production version",
                    ' ',
                    data.emailTemplate.productionVersion.version));
            }
            if (data.emailTemplate.stagingVersion) {
                return (react_1.default.createElement(NewEmailView_1.NewEmailView, { template: data.emailTemplate, templateVersion: data.emailTemplate.stagingVersion },
                    "Start new email with staging version",
                    ' ',
                    data.emailTemplate.stagingVersion.version));
            }
            return null;
        } },
        react_1.default.createElement(OsmosysResourcePage_1.OsmosysResourcePageInner, null, data => {
            const template = data.emailTemplate;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: "/templates/:id/:subResource(versions)?/:subResourceID(\\d+)?", component: index_1.Versions, componentProps: {
                        template,
                    } }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/templates/:id/versions/:versionId", component: index_1.EmailTemplateVersionModal, componentProps: {
                        template,
                    } }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/templates/:id/new-version", component: index_1.NewVersion, componentProps: {
                        template,
                    } }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/templates/:id/production", component: index_1.Production, componentProps: {
                        template,
                    } }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/templates/:id/staging", component: index_1.Staging, componentProps: {
                        template,
                    } }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/templates/:id/deployments", component: index_1.Deployments, componentProps: {
                        template,
                    } }),
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/templates/:id/settings", component: index_1.Settings, componentProps: {
                        template,
                    } })));
        })));
};
exports.default = exports.EmailTemplateDetail;
//# sourceMappingURL=index.js.map